import React from 'react';
import imageUrl from '../../resources/images/banner.jpg';

const style = {
  backgroundImage: 'url(' + imageUrl + ')',
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
}

const LayoutBanner = () => (
  <div>
    <div className="re-page-banner" style={style}>
      <div className="overlay"></div>
    </div>
  </div>
);

export default LayoutBanner;



// WEBPACK FOOTER //
// ./src/components/page-layouts/layoutBanner.js